import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  dialogContentFullScreen: {
    color: "#000",
    fontSize: "17px"
  }
}));
